import { Helpers } from "../../../core/src/helpers";
import { StoreAppAPI } from "../../../core/src/storeapp-api-client";

/**
  * Add batch functionality to the HPServices api
  * TODO: make this more generic to work for potentially any API
  */
const DISABLE_POLLING = false;
//no point in polling more than every three minutes since currently akamai caches redemption percentages for 2 minutes
const MINIMUM_POLLING_INTERVAL = 1000 * 60 * 3;
//temp limit till idle check is implemented
const MAX_POLL_COUNT = 30;
//const testData=  {"jsonAvailableDeals":[{"PROMO_PRICE":239,"PX_PROMOTION_ID":10498063,"RDMDPCT":"40.0","PRICING_TIER":"US_Store ProductsPriceList","PRIORITY":700,"END_DATE":"2018-10-12 22:00:00","REDEMP_LIMIT":10,"BASE_PRICE":359,"STORE_ID":10151,"PROMOTION_TYPE":"ProductLevelPerItemValueDiscount","STATUS":1,"PER_ORDER_LIMIT":-1,"START_DATE":"2018-09-07 15:30:00","CATENTRY_ID":"3074457345618821818","AVAIL_QUANTITY":1,"DEAL_ADM_NAME":"INTRA_DAY_001","PRODUCT_TYPE":"STO","DEAL_OFFER_TYPE":"AmountOff","EXCLUSIVE":4,"PER_SHOP_LIMIT":-1,"DEAL_OFFER_VALUE":"110"},{"PROMO_PRICE":4.99,"PX_PROMOTION_ID":10501058,"PRICING_TIER":"US_Store ProductsPriceList","PRIORITY":700,"END_DATE":"2018-10-12 01:00:00","REDEMP_LIMIT":-1,"BASE_PRICE":9.99,"STORE_ID":10151,"PROMOTION_TYPE":"ProductLevelPerItemValueDiscount","STATUS":1,"PER_ORDER_LIMIT":-1,"START_DATE":"2018-09-07 13:00:00","CATENTRY_ID":"3074457345618849821","AVAIL_QUANTITY":110,"DEAL_ADM_NAME":"INTRA_DAY_002","PRODUCT_TYPE":"STO","DEAL_OFFER_TYPE":"AmountOff","EXCLUSIVE":4,"PER_SHOP_LIMIT":-1,"DEAL_OFFER_VALUE":"5"},{"PROMO_PRICE":19.99,"PX_PROMOTION_ID":"3074457345618816820","PRICING_TIER":"US_Store ProductsPriceList","PRIORITY":700,"END_DATE":"2018-10-12 03:00:00","REDEMP_LIMIT":8,"BASE_PRICE":24.99,"STORE_ID":10151,"PROMOTION_TYPE":"ProductLevelPerItemValueDiscount","STATUS":1,"PER_ORDER_LIMIT":-1,"START_DATE":"2018-09-07 15:00:00","CATENTRY_ID":"3074457345618816820","AVAIL_QUANTITY":7,"DEAL_ADM_NAME":"INTRA_DAY_004","PRODUCT_TYPE":"STO","DEAL_OFFER_TYPE":"AmountOff","EXCLUSIVE":4,"PER_SHOP_LIMIT":-1,"DEAL_OFFER_VALUE":"5"}]};

class DealsAPI {
  constructor() {
    this.hydrating = false;
    this.pollCount = 0;
  }

  parseDeal(deal) {
    let {
      REDEMP_LIMIT: limit,
      START_DATE: startDate,
      END_DATE: endDate,
      RDMDPCT: redeemedPercent,
      STATUS: active,
      CATENTRY_ID: itemId,
      PROMO_PRICE: dealPrice
    } = deal;

    //calculate units remaing if there is a redemption limit
    const unitsLeft = limit && limit > -1 ? Math.floor(limit * (1 - ((redeemedPercent || 0) / 100))) : - 1;

    //convert dates to local time
    startDate = Helpers.date.utcToLocalTime(startDate);
    endDate = Helpers.date.utcToLocalTime(endDate);

    return {
      itemId,
      startDate,
      endDate,
      limit,
      redeemedPercent,
      unitsLeft,
      dealPrice
    };
  }

  mapResponse(data) {
    let parsedDeals = {
      dealsFetched: true
    };
    let deals = typeof data === 'string' ? JSON.parse(
      Helpers.decodeHtml(data)
        .replace(/"CATENTRY_ID":([\d]{1,})/ig, '"CATENTRY_ID":"$1"')
    ) : data;
    //initialize to emtpy array if unavailable
    deals.jsonFutureDeals = (deals.jsonFutureDeals || []);
    deals.jsonAvailableDeals = (deals.jsonAvailableDeals || []);
    deals.jsonExpiredDeals = (deals.jsonExpiredDeals || []);

    //as the deals are parsed
    //calculate roughly when the data should be refreshed
    let dealRefreshInterval = Number.MAX_SAFE_INTEGER;
    //boolean check to see if there are any active or future deals
    let activeOrUpcomingDeals = (deals.jsonFutureDeals.length + deals.jsonAvailableDeals.length) > 0;

    //parse future deals
    deals.jsonFutureDeals.reduce((result, deal) => {
      const pDeal = this.parseDeal(deal);
      const { itemId } = pDeal;
      result[itemId] = result[itemId] || {};
      result[itemId].futureDeal = pDeal

      //at a minimum check the deal api again
      //when the first future deal starts
      dealRefreshInterval = Math.min(dealRefreshInterval, pDeal.startDate - new Date());

      return result;
    }, parsedDeals);

    //parse available deals
    deals.jsonAvailableDeals.reduce((result, deal) => {
      const pDeal = this.parseDeal(deal);
      const { itemId, unitsLeft } = pDeal;
      result[itemId] = result[itemId] || {};
      result[itemId].activeDeal = pDeal

      //at a minimum check the deal api again when
      //an available deal is set to expire
      dealRefreshInterval = Math.min(dealRefreshInterval, pDeal.endDate - new Date());

      //if there is a redemption limit, wait 1 miniute for every
      // 100 units remaining
      if (unitsLeft > -1) {
        dealRefreshInterval = Math.min(dealRefreshInterval, (unitsLeft / 100) * 60000)
      }

      return result;
    }, parsedDeals);

    //parse expired deals, no need to update refresh time based on expired deals
    deals.jsonExpiredDeals.reduce((result, deal) => {
      const pDeal = this.parseDeal(deal);
      const { itemId } = pDeal;
      result[itemId] = result[itemId] || {};
      result[itemId].expiredDeal = pDeal
      return result;
    }, parsedDeals);

    //finally never allow the refresh
    //interval to dip below minimum allowed
    dealRefreshInterval = Math.max(dealRefreshInterval, MINIMUM_POLLING_INTERVAL);



    if (DISABLE_POLLING || !activeOrUpcomingDeals) {
      return { deals: parsedDeals }
    } else {
      //TEMP fix to prevent deal polling to happen on the top of the hour
      let nextDate = new Date();
      nextDate.setMilliseconds(dealRefreshInterval)
      if (nextDate.getMinutes() < 5) {
        //if next poll will happen at the top of the our add to interval
        dealRefreshInterval = (5 - nextDate.getMinutes()) * (1000 * 60)
      }

      return { deals: parsedDeals, dealRefreshInterval };
    }

  }

  fetchDeals(store) {
    let storeAppAPI = new StoreAppAPI();

    if (this.pollCount >= MAX_POLL_COUNT) {
      return Promise.resolve({ maxRequestCount: true, hydrating: true })
    }
    return new Promise((resolve, reject) => {
      if (this.hydrating) {
        return resolve({ hydrating: this.hydrating });
      }

      this.hydrating = true;

      //  etrAPI.intraDayDeals.get().then(({ status , data }) => {
      storeAppAPI.productGroup.get('dealsapi', { _: Date.now() }).then(({ status, data }) => {
        const { deals } = data.metaData;
        const result = this.mapResponse(deals);
        this.hydrating = false;
        this.pollCount += 1;

        if (status == "200") {
          resolve(result);
        } else {
          reject(data);
        }
      }, err => {
        this.hydrating = false;
        reject(err)
      });
    });
  }

}


export default DealsAPI;
